document.addEventListener("DOMContentLoaded", code);

if(window.acf) {
	window.acf.addAction('render_block_preview/type=tyre-search-cta', code);
}

function code(event) {

    //get the first instance of the tyre search cta block or the purchase sidebar
    let tyre_search = document.querySelector('.tyre-search-cta-block, #purchase-sidebar');

    //if the element exists and is sticky
    if(tyre_search && tyre_search.dataset.sticky === 'true') {

        //get the initial position of the element
        const initial_pos = tyre_search.getBoundingClientRect().top + window.pageYOffset;

        //create a placeholder element
        const placeholder = document.createElement('div');
        placeholder.classList.add('hidden', 'max-[1023px]:!hidden'); //hide on mobile, hide on desktop by default

        //insert the placeholder element before the tyre search block
        tyre_search.parentNode.insertBefore(placeholder, tyre_search);

        //add scroll event listener
        window.addEventListener('scroll', () => {

            //if the user has scrolled past the initial position of the element
            if (window.pageYOffset >= initial_pos) {

                //add the sticky class to the element
                tyre_search.classList.add('sticky-search');

                //set the placeholder dimensions to match the element
                placeholder.style.width = tyre_search.offsetWidth + 'px';
                placeholder.style.height = tyre_search.offsetHeight + 'px';

                //reveal the placeholder (on desktop)
                placeholder.classList.remove('hidden');
            } else { //otherwise the user is at the top of the page or above the initial position

                //remove the sticky class from the element
                tyre_search.classList.remove('sticky-search');

                //reset the placeholder
                placeholder.style.width = '0px';
                placeholder.style.height = '0px';

                //hide the placeholder (on desktop)
                placeholder.classList.add('hidden');
            }
        });
    }
}